import Link from '@/lib/nav/link';
import { ForwardIcon as ArrowRight } from '@/components/icons/line/forward';
import { AutoIcon as Sparkles } from '@/components/icons/line/auto';
import { SignupModalButton } from '@/components/auth/SignupModalButton';
import { Logo } from '@/components/branding/Logo';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { LANDING_HERO_PHOTO } from '@/lib/marketing/photo-assets';

const TRUST_POINTS = ['Kid-aware days', 'Beautiful routes', 'Shareable plans'];

export const Hero = () => {
  return (
    <section className="relative min-h-[86svh] overflow-hidden bg-black text-white">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${LANDING_HERO_PHOTO.url})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.35)_0%,rgba(0,0,0,0.6)_70%,rgba(0,0,0,0.78)_100%)]" />

      <div className="relative z-10 mx-auto flex min-h-[86svh] max-w-7xl flex-col justify-between px-4 pb-10 pt-14 md:px-8 md:pb-16 md:pt-20">
        <div className="flex items-center justify-between">
          <Logo variant="full" width={220} height={104} className="h-16 w-auto md:h-20" priority />
          <Link
            href="/login"
            className="rounded-full bg-primary px-4 py-2 text-sm font-bold text-primary-foreground transition hover:bg-primary/90"
          >
            Sign In
          </Link>
        </div>

        <div className="flex flex-col items-center space-y-6 pb-2 text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/18 bg-white/12 px-3 py-2 text-xs font-bold uppercase tracking-wide text-white/82 backdrop-blur">
            <Sparkles className="h-3.5 w-3.5 text-[hsl(var(--sunlight))]" />
            Family-first AI travel planning
          </div>

          <div className="space-y-4">
            <h1 className="mx-auto max-w-4xl text-wrap font-display text-4xl font-black leading-[0.98] tracking-tight sm:text-5xl md:text-7xl lg:text-8xl">
              Family trips that feel beautifully planned.
            </h1>
            <p className="mx-auto max-w-2xl text-lg leading-8 text-white/82 md:text-xl">
              Roam Together turns messy family travel ideas into photo-rich itineraries, calm
              logistics, and days that actually work with kids.
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:justify-center">
            <SignupModalButton
              className={cn(
                buttonVariants({ size: 'lg' }),
                'h-[52px] rounded-full px-6 text-base font-black shadow-xl shadow-black/25',
              )}
            >
              Start Planning Free
              <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" />
            </SignupModalButton>
          </div>

          <div className="flex flex-wrap justify-center gap-2">
            {TRUST_POINTS.map((point) => (
              <span
                key={point}
                className="rounded-full border border-white/15 bg-white/10 px-3 py-1.5 text-sm font-bold text-white/78 backdrop-blur"
              >
                {point}
              </span>
            ))}
          </div>
        </div>

        {LANDING_HERO_PHOTO.showInlineCredit !== false ? (
          <p className="mx-auto max-w-xl text-center text-xs leading-5 text-white/45">
            {LANDING_HERO_PHOTO.credit}. {LANDING_HERO_PHOTO.licenseNote}
          </p>
        ) : (
          <span aria-hidden="true" />
        )}
      </div>
    </section>
  );
};
